import { rand, randFloat, randCurrencyCode, randBoolean } from '@ngneat/falso';

import { Risks, RisksTypes } from '../base';

export class MockRisks extends Risks {
   constructor() {
      super({
         type: rand([ ...RisksTypes ]),
         amount: +randFloat(),
         currency: randCurrencyCode(),
      });

      this.dangerousGoods = randBoolean();
   }
}
